import Login from "./views/Login";
import LoginW from "./views/LoginW";
import * as moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

/**
 * 存储localStorage
 */
export const setStore = (name, content, persis = true, maxAge = null) => {

  if (!global.window || !name || !global.window.localStorage || !global.window.sessionStorage) {
    return
  }
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  let storage = persis && global.window.localStorage || global.window.sessionStorage;

  storage.setItem(name, content);
  if (!!maxAge && !isNaN(parseInt(maxAge))) {
    storage.setItem(`${name}_expires`, moment().add(maxAge, 's').format('X'));
  }
};

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!global.window || !name || !global.window.localStorage || !global.window.sessionStorage) return;

  // 优先从sessionStorage中获取
  var content = window.sessionStorage.getItem(name),
    _expires = window.sessionStorage.getItem(`${name}_expires`);

  if (!content) {
    content = window.localStorage.getItem(name);
    _expires = window.localStorage.getItem(`${name}_expires`);
  }
  // 设置了过期时间戳 且 已过期
  if (!!_expires && moment.unix(_expires).isBefore(moment())) {
    return;
  }

  try {
    return JSON.parse(content);
  } catch (error) {
    return content;
  }
};





export const install = (Vue) => {
  var div = document.createElement('div');
  var el = document.createElement('div');
  div.appendChild(el);
  document.body.appendChild(div);

  function dialog(Component, config) {

    var DialogInstance = null;

    function close() {
      destroy.apply(undefined, arguments);
    }

    function destroy() {
      if (DialogInstance && div.parentNode) {
        DialogInstance.$destroy();
        DialogInstance = null;
        // div.parentNode.removeChild(div);
      }

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var triggerCancel = args && args.length && args.some(function (param) {
        return param && param.triggerCancel;
      });
      if (config && config.onCancel && triggerCancel) {
        config.onCancel.apply(config, args);
      }
    }

    function render(props) {
      var DialogProps = {
        props: props
      };
      return new Vue({
        el: el,
        render: function render() {
          var h = arguments[0];
          return h(Component, DialogProps);
        }
      });
    }

    DialogInstance = render(Object.assign({}, config, {
      visible: true,
      close: close
    }));

    return {
      destroy: close
    };
  }

  Object.defineProperty(Vue.prototype, '$loginFrm', {
    get: function get() {
      return (config) => {
        var that = this;
        dialog(Login, Object.assign({}, config, {
          inviteCode: this.$route.query.inviteCode,
          success() {
            location.href = that.$route.fullPath ;
            // that.$router.go(0);
          }
        }))
      }
    }
  });
  Object.defineProperty(Vue.prototype, '$loginFrm2', {
    get: function get() {
      return (config) => {
        var that = this;
        dialog(LoginW, Object.assign({}, config, {
          inviteCode: this.$route.query.inviteCode,
          success() {
            location.href = "/";
            // that.$router.go(0);
          }
        }))
      }
    }
  });
  Object.defineProperty(Vue.prototype, '$dialog', {
    get: function get() {
      return (component, config) => {
        dialog(component, config)
      }
    }
  });


  Object.defineProperty(Vue.prototype, '$refreshAccountInfo', {
    get: () => {
      return function () {
        this.$http
          .post("/zzAccountInfo")
          .then(res => {
            if (!res.error) {
              this.$store.dispatch("SetAccountInfo", res.data);
            }
          })
      }
    }
  });

  Vue.prototype.moment = moment;
  Vue.prototype.$setStore = setStore;
  Vue.prototype.$getStore = getStore;
  Vue.prototype.$getWetchatExplore= function () {
    var ua = window.navigator.userAgent.toLowerCase();
    var res=(ua.match(/MicroMessenger/i))&&((ua.match(/MicroMessenger/i))[0]=="micromessenger")||false;
    return res;
  }

}